
























































import { Component } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import HasValidation from "@/mixins/HasValidation";
import Context from "@/mixins/context";
import { ClientRoutes } from "@/data/enums/router";

@Component({
  components: {
    "create-password": () =>
      import("@/components/app/global/fields/createPasswordField.vue")
  }
})
export default class SetPasswordForm extends mixins(HasValidation, Context) {
  // Data
  private isProcessing = false;
  private isExpiredOrInvalid = false;

  private usernameDisabled = false;
  private password = "";
  private username = "";
  private hash = "";
  private expires = "";

  public created() {
    this.username = this.$_.get(this.$route.query, "username", "") as string;
    this.hash = this.$_.get(this.$route.query, "hash", "") as string;
    this.expires = this.$_.get(this.$route.query, "expires", "") as string;

    if (this.expires) {
      // Check if link has expired
      if (this.$moment.utc(this.expires).toDate() <= new Date()) {
        return (this.isExpiredOrInvalid = true);
      }
    }

    if (this.username.length) {
      this.usernameDisabled = true;
    }

    if (!this.hash.length) {
      this.$buefy.toast.open({
        message: this.$t("_sentence.invalid_set_password_link") as string,
        type: "is-danger"
      });
      this.$router.push(this.redirectRoute);
    }
  }

  public get redirectRoute() {
    return this.isAdmin
      ? { name: "adminDashboard" }
      : { name: ClientRoutes.DASHBOARD };
  }

  public get completeRegistration() {
    return this.isAdmin
      ? "auth/admin/completeUserRegistration"
      : "auth/client/completeRegistration";
  }

  public get isDisabled() {
    return this.hasErrors || this.isProcessing || !this.password.length;
  }

  public async setPassword() {
    this.isProcessing = true;
    this.validate()
      .then(async result => {
        if (result) {
          await this.$store.dispatch(this.completeRegistration, {
            password: this.password,
            reg_hash: this.hash,
            username: this.username
          });

          return this.$buefy.toast.open({
            message: this.$t(
              "_sentence.account_activation_was_successful"
            ) as string
          });
        }
        this.isProcessing = false;
        this.$buefy.toast.open({
          message: this.$t("_.form_invalid") as string,
          type: "is-danger"
        });
      })
      .catch(async error => {
        this.$store.dispatch("api/handleValidationError", {
          error,
          vm: this
        });
        this.isExpiredOrInvalid = true;
        this.isProcessing = false;
      });
  }
}
